import { render, staticRenderFns } from "./DepositoCreate.vue?vue&type=template&id=0581cc15&scoped=true&"
import script from "./DepositoCreate.vue?vue&type=script&lang=js&"
export * from "./DepositoCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0581cc15",
  null
  
)

export default component.exports